import { FC } from "react";

import Image from "../BaseComponents/Image";

import {
  StyledIconText,
  StyledInfoText,
  StyledOuterContainer,
} from "./NotFound.styles";

import { useMediaQuery } from "context/media/MediaContext";

import { NotFoundProps } from "./NotFound.constants";

const NotFound: FC<NotFoundProps> = ({ srcSet, info, title }) => {
  const isMobile = useMediaQuery();
  return (
    <StyledOuterContainer>
      {!!srcSet?.length && (
        <Image
          alt='Notfound Icon'
          height={isMobile ? "68px" : "88px"}
          srcSet={srcSet}
          width={isMobile ? "68px" : "88px"}
        />
      )}
      <StyledIconText>{title}</StyledIconText>
      <StyledInfoText>{info}</StyledInfoText>
    </StyledOuterContainer>
  );
};

export default NotFound;
